import { Dispatch, SetStateAction, useState } from 'react';

import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { GET_CURRENT_MANAGERS_QUERY } from '@/components/dueDiligence-page/queries';
import Input from '@/components/basicComponents/input';
import { themeVar } from '@/styles/theme';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';

interface CreateManagerProps {
  isOpen: boolean;
  managerList: string[];
  setManagerList: Dispatch<SetStateAction<string[]>>;
  setNewManagerId: (newManagerId: string) => void;
  onClose: () => void;
}

const CreateManager = ({ isOpen, managerList, setManagerList, setNewManagerId, onClose }: CreateManagerProps) => {
  const [value, setValue] = useState('');

  useQuery(GET_CURRENT_MANAGERS_QUERY, {
    onCompleted: (data) => {
      setManagerList(data.getCurrentManagers.values);
    }
  });

  const saveValue = () => {
    setManagerList([...new Set([value, ...managerList])].sort((a: string, b: string) => a.localeCompare(b)));
    setNewManagerId(value);
    onClose();
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      confirmButton={{
        name: 'Save',
        onClick: saveValue,
        disabled: !value.length
      }}
      showRequiredFields
    >
      <ModalContainer>
        <ModalTitel>Create New Manager</ModalTitel>
        <ModalDescription>Managers are used to group one or more investments.</ModalDescription>
      </ModalContainer>
      <ManagerInputWrapper>
        <Input
          label="Manager Name"
          placeholder="Provide a name"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          type="text"
          size="lg"
          isRequiredField
          autoFocus
        />
      </ManagerInputWrapper>
    </ModalWrappedContent>
  );
};

export default CreateManager;

const ModalContainer = styled.div`
  font-weight: 400;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 19px;
  line-height: 27px;
  text-align: center;
  color: ${themeVar('font.base')};
`;

const ManagerInputWrapper = styled.div`
  padding-top: 35px;
`;
